import type { CSSProperties, FC } from 'react';
import { useTranslation } from 'react-i18next';

const styles: Record<string, CSSProperties> = {
  root: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center'
  },
  title: {
    fontWeight: 400
  },
  description: {
    margin: 0,
    color: 'var(--text-weak)'
  }
};

const NotFoundPage: FC = () => {
  const { t } = useTranslation();
  return (
    <div style={styles.root}>
      <h2 style={styles.title}>{t('not_found.title')}</h2>
      <p style={styles.description}>{t('not_found.description')}</p>
    </div>
  );
};

export default NotFoundPage;
